import React from 'react';

import { Tooltip } from '@material-ui/core';
import { Clock } from 'lucide-react';
import { useUnsafeTranslation } from '../../../../../i18next';
import { Timestamp } from '../../../../../services/time';

export const CustomizedTimingHint = ({
  type,
  customizedTiming,
  at
}: {
  type: 'task' | 'message' | 'automation';
  customizedTiming: boolean | undefined;
  at: Timestamp;
}) => {
  const { t } = useUnsafeTranslation();
  if (!customizedTiming || at.toMillis() < Date.now()) {
    return null;
  }
  const tooltip = t(
    'This {{ type }} has a customized timing. Changes to its timing on the template level will not propagate to it.',
    {
      type: t(type)
    }
  );
  return (
    <Tooltip title={tooltip}>
      <Clock size={16} />
    </Tooltip>
  );
};